// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"552":"transactions","768":"portfolio-details","884":"admin","945":"dashboard"}[chunkId] + "." + {"552":"d49b1634","768":"a1506c99","884":"b1068244","945":"ed5f1ac5"}[chunkId] + ".css";
};